
  import WorklogDetailsDialog from "@/views/Accounting/WorklogDetailsDialog/WorklogDetailsDialog.vue";
  import Vue from "vue";
  import {MessageTypes} from "@/components/message-types";
  import CreateWorklogParameters from "@/views/Accounting/WorklogDetailsDialog/CreateWorklogParameters";
  import {isAuthorized} from "@/mixin/mixins";
  import OrderServiceV2 from "@/service/OrderServiceV2";
  import Order from "@/model/Order";
  import store, {GeneralGetters} from "@/store/store";
  import moment from "moment/moment";

  export default Vue.extend({
    name: "OrderWorklogsCreateFab",
    components: {
      WorklogDetailsDialog
    },
    props: {
      order: {
        type: Object,
        default: (): any => null
      }
    },
    data: () => ({
      createAllowed: false,
      loadedOrder: null as Order | null
    }),
    computed: {
      date(): string | null {
        return this.$route.query.date ? this.$route.query.date as string : null;
      },
      isDate(): boolean {
        return this.$moment(this.date as string, "YYYY-MM-DD", true).isValid();
      },
      isVisible(): boolean {
        if (this.orderUuid) {
          return this.createAllowed && isAuthorized("Order_Worklogs_CreateWorklog");
        } else {
          return isAuthorized("Accounting_Employee_CreateWorklogs");
        }
      },
      isYearMonth(): boolean {
        return this.$moment(this.date as string, "YYYY-MM", true).isValid();
      },
      orderUuid(): string | undefined {
        return this.$route.params.orderUuid;
      }
    },
    mounted() {
      if (this.orderUuid) {
        let authorized = isAuthorized("Accounting_Employee_CreateWorklogs")
          || isAuthorized("Order_Worklogs_CreateWorklog");

        if (authorized) {
          let earliestValidFrom = store.getters[GeneralGetters.GET_EARLIEST_VALID_FROM];
          OrderServiceV2.getOrderByUuid(this.orderUuid)
            .then(order => {
              this.loadedOrder = order;
              this.createAllowed = order.validTo == null || moment(order.validTo).isSameOrAfter(earliestValidFrom);
            });
        }
      }
    },
    methods: {
      create() {
        const createWorklogParams = new CreateWorklogParameters();
        // The order prop from Order.vue may still be empty, the order loaded here is not
        const order = this.loadedOrder ?? this.order;
        if (order) {
          createWorklogParams.order = order;
        }

        if (this.date) {
          if (this.isDate) {
            createWorklogParams.date = this.date;
          } else if (this.isYearMonth) {
            const date = this.$moment(this.date as string, "YYYY-MM").format("YYYY-MM-01");
            createWorklogParams.date = date;
          }
        }

        this.$eventBus.$emit(MessageTypes.CREATE_WORKLOG, createWorklogParams);
      }
    }
  });
